import React from "react";
import { Tb3DCubeSphere } from "react-icons/tb";
import { BiSolidColor } from "react-icons/bi";
import Slider from "rc-slider";
import "rc-slider/assets/index.css";

import DynamicLineChart from "./realmComponents/DynamicLineChart.js";
import DynamicStringMetricChart from "./realmComponents/DynamicStringMetricChart.js";

const orangeColor = "#c97b06";

const MetricItem = ({
  metric,
  isNumeric,
  isOpen,
  meta,
  setOpenNumericMetric,
  setOpenStringMetric,
  handleMetricClick,
  selectedMetric,
  selectedKey,
  numericSummary,
  keySummary,
  selectedYearEditing,
  selectedRange,
  setSelectedYearEditing,
  availableDates,
  marks,
  toIsoWithOffset,
  longstandingGeoJSONRef,
  polygonCustomLayerRef,
  multuGroupSelectedArray,
  setMultuGroupSelectedArray,
  setGlobalPolygonTransparency,
  numericTimeAggregationMethod,
  IsLoadingNewGeoJSONFromAnUpdate
}) => {

  const borderColor = !isNumeric ? orangeColor : "#29645D";

  return (
    <div
      style={{
        marginTop: "5px",
        marginBottom: "5px",
        border: `1px solid ${borderColor}`,
        borderRadius: "3px"
      }}
    >

      <button
        onClick={() => {
          if (isNumeric) {
            if (!isOpen) {
              setOpenNumericMetric(metric);
              handleMetricClick?.({
                metric,
                isNumeric: true
              });
            }
          } else {
            if (!isOpen) {
              setOpenStringMetric(metric);
              handleMetricClick?.({
                metric,
                isNumeric: false
              });
            }
          }
        }}
        style={{
          width: "100%",
          paddingLeft: "5px",
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          cursor: "pointer",
        }}
      >

        <span style={{
          display: "flex",
          alignItems: "center",
          gap: "5px"
        }}>

          {meta.name || metric}

          {!isNumeric && isOpen && (
            <span style={{
              fontSize: "10px",
              marginLeft: "5px"
            }}>
              <b>
                {(() => {
                  const date = new Date(selectedYearEditing);
                  const day = String(date.getDate()).padStart(2, "0");
                  const month = String(date.getMonth() + 1).padStart(2, "0");
                  const year = String(date.getFullYear()).slice(-2);

                  return `${day}/${month}/${year}`;
                })()}
              </b>
            </span>
          )}

          {isNumeric && isOpen && (
            <span style={{
              fontSize: "10px",
              marginLeft: "5px"
            }}>
              <b>
                {(() => {
                  const date = new Date(selectedYearEditing);
                  const day = String(date.getDate()).padStart(2, "0");
                  const month = String(date.getMonth() + 1).padStart(2, "0");
                  const year = String(date.getFullYear()).slice(-2);

                  return `${day}/${month}/${year}`;
                })()}
                {" • "}
                {
                  typeof numericSummary?.[metric]?.[selectedYearEditing] === "number"
                    ? numericSummary[metric][selectedYearEditing].toFixed(2)
                    : numericSummary?.[metric]?.[selectedYearEditing] ?? "N/A"
                }
              </b>
            </span>
          )}

        </span>


        <div
          style={{
            color: "#fff",
            fontSize: "14px",
            opacity:
              isNumeric
                ? metric === selectedMetric ? 1 : 0.3
                : metric === selectedKey ? 1 : 0.3,

            backgroundColor:
              isNumeric
                ? metric === selectedMetric ? "#29645D" : "#4C5758"
                : metric === selectedKey ? orangeColor : "#4C5758",

            padding: "6px 8px 5px 9px"
          }}
        >
          {
            isNumeric
              ? <Tb3DCubeSphere />
              : <BiSolidColor />
          }
        </div>

      </button>


      {isOpen && (
        <div style={{
          marginTop: "8px",
          marginBottom: "10px",
          padding: "5px"
        }}>

          {isNumeric ? (

            <DynamicLineChart
              value={numericSummary?.[metric] || {}}
              valuePropertyName={meta.name}
              comparisonValue={keySummary?.[metric] || {}}
              unit={metric}
              height={200}
              isEnlarged={true}
              selectedYearEditing={selectedYearEditing}
              selectedRange={selectedRange}
              multuGroupSelectedArray={multuGroupSelectedArray}
              setSelectedYearEditing={setSelectedYearEditing}
              availableDates={availableDates}
              numericTimeAggregationMethod={numericTimeAggregationMethod}
              longstandingGeoJSONRef={longstandingGeoJSONRef}
              IsLoadingNewGeoJSONFromAnUpdate={IsLoadingNewGeoJSONFromAnUpdate}
            />

          ) : (

            <>

              <DynamicStringMetricChart
                metric={metric}
                catgeoryPropertyName={meta.name}
                keySummary={keySummary}
                selectedYearEditing={selectedYearEditing}
                longstandingGeoJSONRef={longstandingGeoJSONRef}
                selectedKey={selectedKey}
                polygonCustomLayerRef={polygonCustomLayerRef}
                multuGroupSelectedArray={multuGroupSelectedArray}
                setMultuGroupSelectedArray={setMultuGroupSelectedArray}
                setGlobalPolygonTransparency={setGlobalPolygonTransparency}
                setSelectedYearEditing={setSelectedYearEditing}
                availableDates={availableDates}
                IsLoadingNewGeoJSONFromAnUpdate={IsLoadingNewGeoJSONFromAnUpdate}
              />

            </>
          )}

        </div>
      )}

    </div>
  );
};


export default MetricItem;